import { render } from "./QuizEditor.vue?vue&type=template&id=59f894b5&scoped=true"
import script from "./QuizEditor.vue?vue&type=script&lang=js"
export * from "./QuizEditor.vue?vue&type=script&lang=js"

import "./QuizEditor.vue?vue&type=style&index=0&id=59f894b5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f894b5"]])

export default __exports__